// src/views/admin/pos/component/DataTable.jsx
import React from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import PermissionCheck from '@/components/common/PermissionCheck';

const DataTable = ({
  isLoading,
  tableColumn,
  dataSource,
  totalRecord,
  dataFilter,
  onChangePage,
  deleteRecord,
}) => {
  const statusOptionList = [
    { value: 1, label: 'Pending' },
    { value: 2, label: 'Placed' },
    { value: 3, label: 'Accept' },
    { value: 4, label: 'Processing' },
    { value: 5, label: 'Out for delivery' },
    { value: 6, label: 'Delivered' },
    { value: 7, label: 'Canceled' },
    { value: 8, label: 'Rejected' },
    { value: 9, label: 'Returned' },
  ];

  return (
    <TableWrapServerSide
      tableColumnList={tableColumn}
      totalDataCount={totalRecord}
      initialPage={dataFilter.page}
      onChangePage={onChangePage}
      per_page={dataFilter.limit}
    >
      {dataSource.length > 0 ? (
        dataSource.map((data) => (
          <tr className="db-table-body-tr" key={data._id}>
            {/* 1. Order ID */}
            <td className="db-table-body-td">
              {data.order_serial_no}
            </td>

            {/* 2. Order Type */}
            <td className="db-table-body-td">
              <span
                className="inline-block px-3 py-1 rounded-full text-sm font-medium"
                style={{
                  backgroundColor: '#FFE3E3',
                  color:           '#F55252',
                }}
              >
                {data.dining_table_id ? 'Dining Table' : 'Takeaway'}
              </span>
            </td>

            {/* 3. Customer */}
            <td className="db-table-body-td">
              {data.user_id?.name}
            </td>

            {/* 4. Amount */}
            <td className="db-table-body-td">
              {data.total}
            </td>

            {/* 5. Date */}
            <td className="db-table-body-td">
              {Moment(data.order_datetime).format('h:mm A, DD-MM-YYYY')}
            </td>

            {/* 6. Status */}
            <td className="db-table-body-td">
              <span
                className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${
                  data.status === 3
                    ? 'bg-green-100 text-green-600'
                  : data.status === 2
                    ? 'bg-blue-100 text-blue-600'
                  : 'bg-gray-100 text-gray-600'
                }`}
              >
                {statusOptionList.find((s) => s.value === data.status)?.label}
              </span>
            </td>

            {/* 7. Actions */}
            <td className="db-table-body-td hidden-print hidden-print-remove">
              <div className="flex gap-1.5">
                <PermissionCheck permsission="view_table_orders">
                  <Link to={`/admin/pos-orders/show/${data._id}`}>
                    <button className="db-table-action view">
                      <i className="lab lab-view" />
                      <span className="db-tooltip">view</span>
                    </button>
                  </Link>
                </PermissionCheck>
                <PermissionCheck permsission="update_pos_orders">
                  <button
                    className="db-table-action delete"
                    onClick={() => deleteRecord(data._id)}
                  >
                    <i className="lab lab-delete" />
                    <span className="db-tooltip">delete</span>
                  </button>
                </PermissionCheck>
              </div>
            </td>
          </tr>
        ))
      ) : (
        <IsLoadingNotFound
          isLoading={isLoading}
          colSpan={tableColumn.length}
        />
      )}
    </TableWrapServerSide>
  );
};

export default DataTable;
